import { PlatformType } from './scene/type';

/**
   * 初始化环境变量
   * 根据ua来判断当前的环境
   */
export function getEnv() {
  let platform: PlatformType;
  platform = PlatformType.MOBILE_OUTSIDE_WX;
  const ua = navigator.userAgent.toLowerCase();
  // 通过ua来判断当前环境是否为端内
  const isWXWork = /wxwork/i.test(ua);
  // 企业微信不可以通过内部浏览器的h5跳转小程序
  const isWeixin = !isWXWork && /micromessenger/i.test(ua);
  if (isWeixin) {
    platform = PlatformType.MOBILE_INSIDE_WX;
  }

  // 通过ua判断是在PC还是在移动端
  if (
    !navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)
  ) {
    platform = PlatformType.PC;
  }
  return platform;
}
